import React from "react";
import { Card, CardContent } from "../../../@/components/ui/card";
import { Button } from "../../../@/components/ui/button";
import { ClipLoader } from "react-spinners";
import { Spinner } from "../spinner";

export default function StatCard({
  icon,
  label,
  value,
  subtitle,
  growth,
  actionText,
  actionIcon,
  actionVariant = "default",
  actionOnClick,
  loading = false,
  className = "",
  contentClassName = "",
  labelClassName = "",
  valueClassName = "",
  subtitleClassName = "",
  iconClassName = "",
  hideAction = false,
  actionDisabled,
}) {
  const shouldRenderAction =
    !hideAction &&
    (typeof actionOnClick === "function" ||
      Boolean(actionText) ||
      Boolean(actionIcon));

  return (
    <Card className={`py-4 h-full rounded-md ${className}`.trim()}>
      <CardContent className={`flex flex-col h-full ${contentClassName}`.trim()}>
        <div className="flex items-center justify-between mb-2">
          <div
            className={`font-heading font-semibold text-(--neutral-900) ${labelClassName}`.trim()}
          >
            {label}
          </div>
          <div className={iconClassName}>{icon}</div>
        </div>
        <div className="flex-1 flex flex-col justify-start">
          <div
            className={`text-h3 font-heading text-(--neutral-950) mb-1 ${valueClassName}`.trim()}
          >
            {loading ? (
              <span className="flex items-center justify-center w-full">
                <Spinner />
              </span>
            ) : (
              value
            )}
          </div>
          {subtitle && (
            <div
              className={`font-body text-(--neutral-800) mt-1 ${subtitleClassName}`.trim()}
            >
              {subtitle}
            </div>
          )}
        </div>
        {shouldRenderAction && (
          <div className="mt-auto">
            <Button
              size=""
              variant={actionVariant}
              onClick={actionOnClick}
              className="w-full font-sans"
              disabled={Boolean(actionDisabled ?? loading)}
            >
              {loading ? (
                <span className="flex items-center justify-center w-full">
                  <ClipLoader size={18} color="#ddd" />
                </span>
              ) : (
                <>
                  {actionText && <span>{actionText}</span>}
                  {actionIcon && <span className={actionText ? "ml-2" : ""}>{actionIcon}</span>}
                </>
              )}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}